import { EntiteSARPModel } from './entite-sarp.model';
import { AgenceModel } from './agence.model';

export class SocieteModel extends EntiteSARPModel {
    public agences?: AgenceModel[];
    public siret: string;
}
